// extracted by mini-css-extract-plugin
module.exports = {"container":"CloseButton_container__23ypK","button":"CloseButton_button__1VZhx","withBorder":"CloseButton_withBorder__2p3Z9","noBorder":"CloseButton_noBorder__1WGuK"};